import { GEN_AI_ENDPOINTS, StreamFetchParams } from '../api/streamFetch';

const createHttpPostRequest = (body: any) => {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
  };
};

// ${base_url}/genai_dsl_transform
const createDslTransformPayload = (props: StreamFetchParams) => {
  const { input, conversationId, nexsetId, context } = props;

  if (!props?.token) throw new Error('You must provide a token');
  if (!props?.input) throw new Error('You must provide an user_query');
  if (!props?.nexsetId) throw new Error('You must provide a nexset_id');
  if (!props?.conversationId) throw new Error('You must provide a session_id');

  const body = JSON.stringify({
    token: props.token,
    user_query: input,
    nexset_id: String(nexsetId),
    session_id: String(conversationId),
    input_context: context?.input_context,
  });

  return createHttpPostRequest(body);
};

// ${base_url}/genai_codegen
const createCodeGenerationPayload = (props: StreamFetchParams) => {
  const { input, conversationId, nexsetId, codeType = 'python' } = props;

  if (!props?.token) throw new Error('You must provide a token');
  if (!props?.input) throw new Error('You must provide an user_query');
  if (!props?.nexsetId) throw new Error('You must provide a nexset_id');
  if (!props?.conversationId) throw new Error('You must provide a session_id');

  const body = JSON.stringify({
    token: props.token,
    user_query: input,
    nexset_id: String(nexsetId),
    session_id: String(conversationId),
    output_language: codeType,
  });

  return createHttpPostRequest(body);
};

// ${base_url}/genai_transform
const createGenAiTransformPayload = (props: StreamFetchParams) => {
  const { input, conversationId, nexsetId } = props;

  if (!props?.token) throw new Error('You must provide a token');
  if (!props?.input) throw new Error('You must provide an user_query');
  if (!props?.nexsetId) throw new Error('You must provide a nexset_id');
  if (!props?.conversationId) throw new Error('You must provide a session_id');

  const body = JSON.stringify({
    token: props.token,
    user_query: input,
    nexset_id: String(nexsetId),
    session_id: String(conversationId),
  });

  return createHttpPostRequest(body);
};

/**
 * Factory function to create the payload for the GenAI API.
 * @param props - The properties for the payload.
 * @returns The payload for the GenAI API.
 */
const createGenAiPayload = (props: StreamFetchParams): any => {
  switch (props.type) {
    case GEN_AI_ENDPOINTS.GENAI_TX_DSL:
      return createDslTransformPayload(props);
    case GEN_AI_ENDPOINTS.GENAI_CODEGEN:
      return createCodeGenerationPayload(props);
    case GEN_AI_ENDPOINTS.GENAI_TRANSFORM:
      return createGenAiTransformPayload(props);
    default:
      throw new Error(`Unknown endpoint type: ${props.type}`);
  }
};

export default createGenAiPayload;
